import axios from 'axios';

export const api = axios.create({
    baseURL: `https://dev-ryzhov.cycles.api.affirmxh.com/v2`,
    headers: {
        'x-api-key': 'ZG8S1OB5.7XzA9ShdZwgVGUKb6eBK0jHqPJBYCcWc'
    }
});